import { endpoints, host } from '@config/endpoints';
import request from './request';

export const exportTopSectorAndOccupationInfo = async (urlDataAPI: any) => {
    const { exportType, type, hubIds, locations, fromTimeline, toTimeline, isEntryLevel } = urlDataAPI;
    const { path, method } = endpoints.occupationAndSector.exportTopSectorAndOccupationInfo;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { exportType, type, hubIds, locations, fromQuarter: fromTimeline, toQuarter: toTimeline, isEntryLevel },
            {
                responseType: "blob"
            },
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
